module.exports = __webpack_public_path__ + "img/Credit.88c72d85.svg";